import PropTypes from "prop-types";

const IconFeature = ({ name, title }) => {
    const featureIcons = {
        newsletter: getNewsletterIcon,
        chat: getChatIcon,
        stream: getStreamIcon,
    };

    let icon;
    if (featureIcons[name]) {
        icon = featureIcons[name]();
    } else if (title) {
        icon = title;
    } else {
        icon = "";
    }

    return <div>{icon}</div>;
};

const getNewsletterIcon = () => {
    return (
        <svg viewBox="0 0 24 24" focusable="false" className="icon-feature">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z" />
        </svg>
    );
};

const getChatIcon = () => {
    return (
        <svg viewBox="0 0 24 24" focusable="false" className="icon-feature">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M20 4v13.17L18.83 16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 10H6v2h12v-2zm0-3H6v2h12V9zm0-3H6v2h12V6z" />
        </svg>
    );
};

const getStreamIcon = () => {
    return (
        <svg viewBox="0 0 24 24" focusable="false" className="icon-feature">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z" />
        </svg>
    );
};

IconFeature.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
};

export default IconFeature;
